import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-self_serve_back-click';
/**
 * Back button click event on self-serve flow during navigation
 */
export function trackHelpCenterSelfServeBackClick(retailerToken, brandToken, url, issue_type2) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { retailerToken, brandToken, url, issue_type2 },
    });
}
